<template>
  <div id="grass-wrapper">
    <div id="grass-layer"></div>
    <div id="grass-overlay" :class="{ nightMode: isNightMode, winter: isWinterMode }"></div>
    <div class="content-wrapper">
      <img src="@/assets/Motso AC2.png" class="top-logo" @click="goHome"/>
       <!-- <div class="player-frame ma-0 pa-0" > -->
        <div id="player"></div>
       <!-- </div> -->
      <v-row>
        <v-col><img src="@/assets/AC rain.png" class="rain-button" :class="{ 'active-weather': isRainMode }" @click="toggleRainMode" /></v-col>
        <v-col><img src="@/assets/AC winter.png" class="snow-button" :class="{ 'active-weather': isWinterMode }" @click="toggleWinterMode" /></v-col>
        <!-- <v-col><img src="@/assets/Motso AC2.png" class="kk-button" /></v-col> -->
        <v-col class="time-toggle">
          <img
            src="@/assets/AC moon.png"
            class="moon-button"
            v-show="!isNightMode"
            @click="changeNightMode"
          />
          <img
            src="@/assets/AC sun.png"
            class="sun-button"
            v-show="isNightMode"
            @click="changeNightMode"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>
  
  <script>
  /* global YT */
  export default {
    data() {
      return {
        youtubeIds: [
          "9j9YEuFeDAw", "UMMRXzXs-_k", "-GS2Uf2koDI", "se7iaIfFdoQ",
          "AzHvhnzxeEw", "1auEF6PRm7Q", "hhlLbg4CRBc", "jcPIAICO-DI",
          "J22dco5U-nY", "odevRs61OqY", "uFq-VvnEa80", "0dzoz1iOvws",
          "4pmZrtO8_co", "dAABrbS8QeA", "hwENcKas4nU", "TMFHHTFEMPQ",
          "_m_cI7cssPQ", "zcIDJd-ncHI", "7nNsOcPfGxk", "T_454gyj9PE",
          "GlYzXvHQaDw", "Au8cSsWgYUY", "nB1xsg-X3-0", "Ar8sNQNvi90"
        ],
        winterIds: [
          "vU4q2k6qxNY", "jPlCCbo9nns", "GL6e7B09i6Q", "NLNs1OqrAgY",
          "rK-7nAKNon0", "5UGkPieMrVM", "tz4uxjEzna4", "AZKFAYkXLS4",
          "Ld0kGoKSIGQ", "9CL8_yHIiIw",
           "uFq-VvnEa80", "0dzoz1iOvws", "4pmZrtO8_co", //these need to be replaced
          "c0nWr_NXND4", 
          "hwENcKas4nU", "TMFHHTFEMPQ", "_m_cI7cssPQ", "zcIDJd-ncHI", "7nNsOcPfGxk", "T_454gyj9PE", "GlYzXvHQaDw", "Au8cSsWgYUY", "nB1xsg-X3-0", "Ar8sNQNvi90" //these too
        ],
        currentHour: new Date().getHours(),
        rainyId: "cNH13M1LqM0",
        player: null,
        timer: null,
        isNightMode: false,
        isRainMode: false,
        isWinterMode: false,
        isKKMode: false,
      };
    },
    methods: {
      initPlayer() {
        const initialVideoId = this.isRainMode
          ? this.rainyId
          : this.isWinterMode
            ? this.winterIds[this.currentHour]
            : this.youtubeIds[this.currentHour];

        this.player = new YT.Player("player", {
          height: `${window.innerHeight / 3}`,
          videoId: initialVideoId,
          playerVars: {
            autoplay: 1,
            controls: 1,
            loop: 1,
            playlist: this.isRainMode ? this.rainyId : undefined // Required for loop to work
          },
          events: {
            onReady: event => event.target.playVideo()
          }
        });

        this.timer = setInterval(this.checkForHourChange, 1000);
      },
      checkForHourChange() {
        const now = new Date().getHours();

        if (now !== this.currentHour) {
          this.currentHour = now;

          if (this.isRainMode) {
            this.player.loadVideoById(this.rainyId);
          } else if (this.isWinterMode) {
            this.player.loadVideoById(this.winterIds[this.currentHour]);
          } else {
            this.player.loadVideoById(this.youtubeIds[this.currentHour]);
          }
        }
      },
      changeNightMode() {
        this.isNightMode = !this.isNightMode;
      },
      toggleRainMode() {
        this.isWinterMode = false
        this.isRainMode = !this.isRainMode;
        const newId = this.isRainMode ? this.rainyId : this.youtubeIds[this.currentHour];

        this.player.loadVideoById(newId);
      },
      toggleWinterMode() {
        this.isWinterMode = !this.isWinterMode;
        if (this.isWinterMode) {
          this.isRainMode = false;
          this.player.loadVideoById(this.winterIds[this.currentHour]);
        } else {
          this.player.loadVideoById(this.youtubeIds[this.currentHour]);
        }
      },
      goHome() {
        console.log("Navigating home...");
        this.$router.push("/");
      },
    },
    mounted() {
      window.vueYouTubeApp = this;

      const hour = new Date().getHours();
      if (hour >= 20 || hour < 6) {
        this.isNightMode = true;
      }

      if (typeof YT === "undefined" || typeof YT.Player === "undefined") {
        const tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        document.body.appendChild(tag);

        window.onYouTubeIframeAPIReady = () => {
          if (window.vueYouTubeApp?.initPlayer) {
            window.vueYouTubeApp.initPlayer();
          }
        };
      } else {
        this.initPlayer();
      }
    },
    beforeUnmount() {
      clearInterval(this.timer);
      if (this.player?.destroy) {
        this.player.destroy();
      }
    },
  };
  </script>
  
  <style scoped>
  @keyframes pan-grass {
    from {
      background-position: center top;
    }
    to {
      background-position: center -1000px; /* 10 × 100px */
    }
  }
  #grass-wrapper {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    position: fixed;
    top: 0;
    left: 0;
  }
  #grass-layer {
    background-image: url('@/assets/ac-grass-pattern.jpg');
    background-size: auto 100px; /* Or adjust to match your design */
    position: absolute;
    left: 50%;
    top: 0;
    translate: -50% 0%;
    width: 100%;
    height: 100%;
    min-width: 1200px;
    opacity: 1;
    animation: pan-grass 60s linear infinite;
    will-change: background-position;
    background-repeat: repeat;
  }
  #grass-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    pointer-events: none;
    transition: background-color 0.4s ease;
    background-color: transparent;
  }
  #grass-overlay.nightMode {
    background-color: rgba(0, 0, 0, 0.644);
  }
  /* #grass-overlay.winter {
    backdrop-filter: grayscale(100%);
  } */
  .content-wrapper {
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;
    z-index: 1;
    position: relative;
  }
  .player-frame {
    border-radius: 10px;
    border: 10px solid #794518;
  }
  .logo-link {
    display: inline-block !important;
    line-height: 0;
    width: fit-content;
  }
  .top-logo {
    height: 33.33vh;
    margin-bottom: 20px;
    transition: transform 0.2s ease;
    cursor: pointer;
  }
  .top-logo:hover {
    transform: scale(1.02);
  }
  #player {
    width: 100%;
    height: 33.33vh;
    max-width: 560px; /* optional: keep a sane upper limit */
    background: transparent;
    /*margin-bottom: 0px;
    padding-bottom: 0px;*/
  }
  .rain-button, .snow-button, .moon-button, .sun-button {
    margin-top: 20px;
    height: 15vh;
    transition: filter 0.3s ease, transform 0.2s ease;
    cursor: pointer;
  }
  .rain-button:hover, .snow-button:hover, .moon-button:hover, .sun-button:hover {
    transform: scale(1.02);
  }
  .active-weather {
    filter: brightness(40%);
    opacity: 1;
    transform: scale(0.98);
    transition: filter 0.3s ease, transform 0.2s ease;
  }
  </style>